const IMAGE_PROXY_BASE_URL = 'https://apisaleeasy.psisat.com/imgproxy';

export const createProxiedImageUrl = (originalImagePath, options = {}) => {
  if (!originalImagePath) return null;
  
  const {
    width = 200,
    height = 200,
    quality = 80,
    format = 'webp',
    fit = 'crop'
  } = options;

  let imageUrl = originalImagePath;
  
  if (originalImagePath.startsWith('~/')) {
    imageUrl = originalImagePath.replace('~/', 'http://61.91.153.68/');
  }
  
  const base64EncodedUrl = btoa(imageUrl);
  const optionsString = `rs:${fit}:${width}:${height}/q:${quality}/f:${format}`;
  
  return `${IMAGE_PROXY_BASE_URL}/${optionsString}/${base64EncodedUrl}`;
};

export const createProfileImageUrl = (imagePath) => {
  return createProxiedImageUrl(imagePath, {
    width: 80,
    height: 80,
    quality: 90,
    format: 'webp',
    fit: 'crop'
  });
};

export const createThumbnailImageUrl = (imagePath) => {
  return createProxiedImageUrl(imagePath, {
    width: 150,
    height: 150,
    quality: 80,
    format: 'webp',
    fit: 'crop'
  });
};